const reasons = [
  {
    icon: 'ri-bar-chart-grouped-line',
    number: '1',
    title: 'Работа с «Лестницей Ханта»',
    intro: 'Большинство ваших клиентов в соцсетях ещё не знают, что им нужен ваш продукт.',
    points: [
      'Ведение работает только с теми, кто уже готов купить.',
      'Маркетинг берёт человека, который просто листает ленту, и за 3–4 касания доказывает ему: «Ваша проблема решается именно здесь».',
    ],
  },
  {
    icon: 'ri-heart-3-line',
    number: '2',
    title: 'Прогрев и доверие',
    intro: 'Люди покупают у людей.',
    points: [
      'Через маркетинг мы упаковываем вашу экспертность.',
      'Мы не просто показываем товар — мы показываем результат, ценности и отзывы.',
      'Это создаёт ту самую «теплоту», после которой клиент не торгуется о цене.',
    ],
  },
  {
    icon: 'ri-map-pin-user-line',
    number: '3',
    title: 'Умное продвижение (Target &amp; Influencers)',
    intro: 'Мы используем рекламные инструменты, чтобы ваши посты видели не ваши друзья, а ваша целевая аудитория.',
    points: [
      'Таргетинг по интересам, геолокации и поведению.',
      'Работа с лидерами мнений для расширения охвата.',
    ],
  },
];

export default function SMMWhyNeeded() {
  return (
    <section id="smm-why" className="py-12 sm:py-24 bg-[#F9F5EF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-question-answer-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Аргументы в пользу
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Почему вашему бизнесу нужен именно
            <span className="block mt-1">Маркетинг в соцсетях?</span>
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="space-y-4 sm:space-y-6">
          {reasons.map((r, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-10 border border-gray-100 hover:border-[#C5A880]/40 transition-all duration-300"
            >
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
                {/* Icon + number block */}
                <div className="flex sm:flex-col items-center gap-4 sm:gap-3 flex-shrink-0 sm:w-24">
                  <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#1A2B4C] rounded-2xl flex items-center justify-center flex-shrink-0">
                    <i className={`${r.icon} text-xl sm:text-2xl text-white`}></i>
                  </div>
                  <span className="text-4xl sm:text-5xl font-bold text-[#C5A880]/25 font-['Playfair_Display'] leading-none sm:text-center">
                    {r.number}
                  </span>
                </div>

                <div className="flex-1">
                  <h3
                    className="text-base sm:text-2xl font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-2 sm:mb-3 leading-snug"
                    dangerouslySetInnerHTML={{ __html: r.title }}
                  />
                  <p className="text-xs sm:text-sm text-gray-500 italic font-['Montserrat'] mb-3 leading-relaxed">
                    {r.intro}
                  </p>
                  <ul className="space-y-2">
                    {r.points.map((pt, pi) => (
                      <li key={pi} className="flex items-start gap-2 sm:gap-3">
                        <div className="w-5 h-5 mt-0.5 rounded-full bg-[#C5A880]/20 flex items-center justify-center flex-shrink-0">
                          <i className="ri-check-line text-[#C5A880] text-xs"></i>
                        </div>
                        <p className="text-xs sm:text-sm text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
                          {pt}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom accent */}
        <div className="mt-8 sm:mt-12 bg-gradient-to-r from-[#1A2B4C] to-[#253D6B] rounded-2xl sm:rounded-3xl p-6 sm:p-10 text-center">
          <p className="text-white/70 text-xs font-['Montserrat'] uppercase tracking-widest font-semibold mb-3">
            Итог
          </p>
          <h3 className="text-base sm:text-2xl md:text-3xl font-['Playfair_Display'] font-bold text-white leading-snug">
            Реклама закончилась — трафик остановился.
            <span className="block mt-2 text-[#C5A880]">SMM-маркетинг — это актив, который работает на вас постоянно.</span>
          </h3>
        </div>
      </div>
    </section>
  );
}
